<template>
    <crud-create
        :open="open"
        :loading="loading"
        :title="title"
        :errorMessage="errorMessage"
        @create="create"
        @close="$emit('close')"
    >
        <cliente-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>
import ClienteProvider from "../../../providers/ClienteProvider";

import { CrudCreate } from "@dracul/common-frontend";
import { ClientError } from "../../../../../errors";

import ClienteForm from "../ClienteForm";

export default {
    name: "ClienteCreate",

    components: { ClienteForm, CrudCreate },

    props: {
        open: { type: Boolean, default: true },
    },

    data() {
        return {
            title: "cliente.creating",
            errorMessage: "",
            inputErrors: {},
            loading: false,
            form: {
                tipoDocumento: 'CUIT',
                numeroDocumento: null,
                razonSocial: null,
                email: null,
                telefono: null,
                domicilio: null,
                condicionIVA: 'RESPONSABLE_INSCRIPTO',
                activo: true,
                listaPreciosVentaDefaultId: null,
                tipoComprobanteDefault: null,
            },
        };
    },

    methods: {
        create() {
            this.$refs.form.validateThenConfirm(() => this.performCreate());
        },
        performCreate() {
            this.loading = true;
            ClienteProvider.createCliente(this.form)
                .then((r) => {
                    if (r) {
                        this.$emit("itemCreated", r.data.clienteCreate);
                        this.$emit("close");
                    }
                })
                .catch((error) => {
                    let clientError = new ClientError(error);
                    this.inputErrors = clientError.inputErrors;
                    this.errorMessage = clientError.i18nMessage;
                })
                .finally(() => (this.loading = false));
        },
    },
};
</script>

<style scoped></style>
